import { deviceFor } from "../responsive";
import { useEffect, useState } from "react";

// ─── RESPONSIVE HOOK ─────────────────────────────────────────────────────────

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < breakpoint
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return isMobile;
}

// "phone", "tablet" or "desktop", kept up to date as the window changes size (also when a phone is turned sideways).
function useDevice() {
  const [device, setDevice] = useState(() => (typeof window === "undefined" ? "desktop" : deviceFor(window.innerWidth)));
  useEffect(() => {
    const handler = () => setDevice(deviceFor(window.innerWidth));
    window.addEventListener("resize", handler);
    window.addEventListener("orientationchange", handler);
    return () => { window.removeEventListener("resize", handler); window.removeEventListener("orientationchange", handler); };
  }, []);
  return device;
}

export { useIsMobile, useDevice };
